import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/reset.css'
import '@/assets/css/global.less'
import '@/assets/css/bg_color.less'
import '@/assets/css/color.less'
import '@/assets/css/fontsize.less'
import '@/assets/css/margin.less'
import '@/assets/css/padding.less'
import '@/assets/css/h.less'
import '@/assets/css/lh.less'
import '@/assets/css/w.less'
import '@/assets/css/ele.less'

console.log(new Promise(() => {}))

import NavBar from '@/components/NavBar'
import Header from '@/components/Header'
import PageUtil from '@/components/Util/PageUtil'
import Upload from '@/components/Util/Upload'
import ImgUtil from '@/components/Util/ImgUtil'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component('page-util',PageUtil)
Vue.component('nav-bar',NavBar)
Vue.component('v-header',Header)
Vue.component('upload',Upload)
Vue.component('img-util', ImgUtil)

import {
  catchErr,
  cookie,
  getArrProp,
  classPropAssign,
  deepClone
} from '@/util'

import Rules from '@/util/rules'

Vue.prototype.$catchErr = catchErr
Vue.prototype.$cookie = cookie
Vue.prototype.$getArrProp = getArrProp
Vue.prototype.$classPropAssign = classPropAssign
Vue.$classPropAssign = classPropAssign
Vue.prototype.$windowHeight = () => window.innerHeight
Vue.$Rules = Rules
Vue.prototype.$dp = deepClone
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js